<template>
  <v-dialog :value="value" max-width="420" @input="$emit('input', $event)">
    <v-card class="rounded-lg text-center pa-6">
      <div class="flex justify-end">
        <v-btn icon small aria-label="Close" @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </div>

      <v-icon size="64" color="primary">mdi-headset</v-icon>

      <div class="text-xl font-bold text-black mt-4">Service Unavailable</div>
      <div class="text-gray-600 mt-2">
        This service is currently unavailable for your account. To
        {{ action }} crypto, please continue via Live Chat or WhatsApp.
      </div>

      <v-btn color="primary" block class="mt-6" @click="openLiveChat">
        <v-icon left>mdi-message-text</v-icon>
        Live Chat
      </v-btn>

      <v-btn
        color="green"
        outlined
        block
        class="mt-3"
        :href="whatsappUrl"
        target="_blank"
        rel="noopener"
      >
        <v-icon left>mdi-whatsapp</v-icon>
        WhatsApp
      </v-btn>

      <v-btn text color="primary" block class="mt-3" @click="close">
        Close
      </v-btn>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ServiceUnavailableModal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    action: {
      type: String,
      default: 'trade'
    }
  },
  data() {
    return {
      whatsappUrl: 'https://wa.me/2348156010101'
    }
  },
  methods: {
    close() {
      this.$emit('input', false)
    },
    openLiveChat() {
      // Freshchat widget loaded in layouts/User.vue.
      if (window.fcWidget) {
        window.fcWidget.open()
        this.close()
        return
      }
      this.$router.push('/user/contact-support')
    }
  }
}
</script>
